var render = function render(){var _vm=this,_c=_vm._self._c;return _c('common-button',{attrs:{"label":_vm.$t('pages.practice.create.create_company.create'),"type":"add-referral","size":"medium","icon":'referral-add'},on:{"click":function($event){return _vm.createCompany()}}})
}
var staticRenderFns = []

export { render, staticRenderFns }